import { ISelectFilterDefinition } from '@evinced-private/ui-common';

import { ConfigurationLabel } from '../../../common/types/ConfigurationTypes';

import { sanitizeConfigurationLabel } from './DataSanitizationHelpers';

export const createFilterFromConfig = (id: string, label: string): ISelectFilterDefinition => ({
	id,
	label,
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: `All ${label.toLowerCase()}s`,
		someItemsSelectedText: (n: number) => `${label}s (${n})`,
		isMultiple: true,
		isSearchable: true,
		id,
		label,
		listboxWidth: '240px'
	}
});

export const createFiltersFromAdditionalLabels = (
	additionalLabels: ConfigurationLabel[]
): ISelectFilterDefinition[] => {
	return additionalLabels.reduce<ISelectFilterDefinition[]>((acc, label, index) => {
		const sanitized = sanitizeConfigurationLabel(label);

		if (sanitized.showAsFilter && sanitized.label) {
			const filterId = sanitized.label || `additionalLabel_${index}`;
			const filterLabel =
				sanitized.displayName || sanitized.label || `Additional Label ${index + 1}`;
			acc.push(createFilterFromConfig(filterId, filterLabel));
		}
		return acc;
	}, []);
};

export const createFiltersFromCoreLabels = (
	coreLabels: ConfigurationLabel[],
	pathname: string,
	isBusinessUnitsRoute: (pathname: string) => boolean
): ISelectFilterDefinition[] => {
	const isOnBusinessUnitsRoute = isBusinessUnitsRoute(pathname);

	return coreLabels.reduce<ISelectFilterDefinition[]>((acc, label, index) => {
		const sanitized = sanitizeConfigurationLabel(label);

		if (sanitized.label) {
			const filterId = sanitized.label || `coreLabel_${index}`;
			const isBusinessUnitFilter = filterId === 'unitId';

			// Skip business-unit filter when on business units route
			if (!(isBusinessUnitFilter && isOnBusinessUnitsRoute)) {
				const filterLabel = sanitized.displayName || sanitized.label || `Core Label ${index + 1}`;
				acc.push(createFilterFromConfig(filterId, filterLabel));
			}
		}
		return acc;
	}, []);
};
